import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { Produktlinie, UebergreifendItem, ZusatzoptionItem } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectSelectedProduktlinie = (state: IAppState): Produktlinie =>
  getSelectedProduktlinie(state.produkt);

export const selectZusatzoptionItems = (state: IAppState): Array<ZusatzoptionItem> => {
  const produktlinie = getSelectedProduktlinie(state.produkt);
  return produktlinie?.zusatzoptionen || [];
};

export const selectProduktlinien = (state: IAppState): Array<Produktlinie> =>
  state.produkt?.produktlinien || [];

export const selectUebergreifend = (state: IAppState): Array<UebergreifendItem> =>
  state.produkt?.uebergreifend || [];

export const selectSelectedZusatzoptionItems = (state: IAppState): Array<ZusatzoptionItem> => {
  return selectZusatzoptionItems(state).filter(elem => elem.isSelected);
};

export const selectSelectedProduktlinieIndex = (state: IAppState): number => {
  return state.produkt.produktlinien.findIndex(produktlinie => produktlinie.selected);
};
